import { useEffect } from 'react'

import { ACTION_CODE, EVENT_CODE } from '@constants'
import { ListControlRedifinitionDataType, ObjectDataRecord } from '@types'

import { EVENT_NAME, subscribe, unsubscribe } from '../../../events'

export const useSetObjectDataOnVariableChange = (
  outerRequestData: ListControlRedifinitionDataType | undefined,
  onVariableChange: (data: ObjectDataRecord) => void
) => {
  useEffect(() => {
    const actions = outerRequestData?.redifinitions?.[0]?.actions

    const setDataOnVarChangeAction = actions?.find(
      action =>
        action.actionCode === ACTION_CODE.SET_DATA &&
        action.eventCode === EVENT_CODE.ON_VARIABLE_CHANGE
    )

    const handleOnVariableChange = (event: CustomEvent) => {
      const actionVariableId = setDataOnVarChangeAction?.variable?.id
      const eventVariableId = event.detail?.id

      if (actionVariableId !== eventVariableId) return

      const variableValue = event.detail.value
      const jsValue = setDataOnVarChangeAction?.jsValue

      const processedValue = jsValue
        ? new Function('srcObj', jsValue)({ variableValue })
        : variableValue

      onVariableChange(processedValue)
    }

    subscribe(EVENT_NAME.CHANGE_VARIABLE_VALUE, handleOnVariableChange)

    return () => {
      unsubscribe(EVENT_NAME.CHANGE_VARIABLE_VALUE, handleOnVariableChange)
    }
  }, [outerRequestData])
}
